<script setup lang="ts">
import { DiscreteNumericValueDto } from '@/api/generator';
import DiscreteNumericValue from '@/components/forms/dataTypes/DiscreteNumericValue.vue';
import {} from '@/components/forms/dataTypes/DiscreteNumericValue.vue';
import { useField, useFieldError } from 'vee-validate';
import { VeeDiscreteNumericValueProps } from '../types';
import { toRef } from 'vue';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeDiscreteNumericValueProps>();

const veeProps = useVeeFormProps(props);

const { errorMessage, value, validate, meta, handleChange } = useField<DiscreteNumericValueDto>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: true,
  },
);

function onUpdate(input: DiscreteNumericValueDto | undefined) {
  handleChange(input, meta.touched);
}

const valueError = useFieldError(toRef(() => `${props.name}.value`));
</script>

<template>
  <DiscreteNumericValue
    v-bind="veeProps"
    :errorMessage="errorMessage || valueError"
    :discreteNumericValue="value"
    @update:discreteNumericList="onUpdate"
    @blur="validate"
  />
</template>
